<button mat-stroked-button color="primary" class="w-100 mt-2" [matMenuTriggerFor]="menu" ><mat-icon>add</mat-icon> {{menuButtonLabel}}</button>
<mat-menu #menu="matMenu">
    <!-- Search Input -->
    <div (click)="$event.stopPropagation()" class="px-2">
        <mat-form-field appearance="outline" class="w-100">
        <mat-label>Search</mat-label>
        <input matInput    [(ngModel)]="searchQuery" (ngModelChange)="filterMenuItems()"/>
        </mat-form-field>
    </div>
    <!-- Menu Items -->
    <ng-container *ngIf="filteredItems.length > 0; else noResults">
      <button mat-menu-item *ngFor="let itemData of filteredItems;let index = index" (click)="onItemClick(itemData.item,index)">
        {{ itemData.displayValue }}
      </button>
    </ng-container>
  
    <!-- No Results -->
    <ng-template #noResults>
      <button mat-menu-item disabled>No results found</button>
    </ng-template>
</mat-menu>
    